import { Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../ui/alert-dialog';
import { Button } from '../../ui/button';

type RemovePaymentMethodDialogProps = {
  onConfirm: () => void;
  isPending?: boolean;
};

export function RemovePaymentMethodDialog({
  onConfirm,
  isPending,
}: RemovePaymentMethodDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 text-muted-foreground hover:text-destructive"
          disabled={isPending}
          aria-label={t('customerPaymentMethods.actions.remove')}
        >
          <Trash2Icon className="w-4 h-4" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('customerPaymentMethods.confirmRemove.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('customerPaymentMethods.confirmRemove.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('customerPaymentMethods.confirmRemove.cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t('customerPaymentMethods.confirmRemove.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
